import { LandCoverYearCoverage, PortfolioSiteMetric } from 'src/shared/types/graph/portfolio';

export type ComparisonPeriod = 'current' | 'lastFull';

export const comparisonYearFor = (years: number[], coverage: LandCoverYearCoverage[], period: ComparisonPeriod): number | undefined => {
    if (period === 'current') {
        return years[years.length - 1];
    } else {
        const completeYears = years.filter(year => coverage.some(entry => entry.year === year && entry.complete));
        return completeYears[completeYears.length - 1];
    }
};

export const baselineYearsBefore = (years: number[], comparisonYear: number): number[] => years.filter(year => year < comparisonYear);

export const baselineYearFor = (years: number[], comparisonYear: number, chosen: number | undefined): number => {
    if (chosen !== undefined && chosen < comparisonYear && years.includes(chosen)) {
        return chosen;
    } else {
        return years[0];
    }
};

export const coversDifferentAssets = (coverage: LandCoverYearCoverage[], baselineYear: number, comparisonYear: number): boolean => {
    const baselineCount = coverage.find(entry => entry.year === baselineYear)?.assetCount ?? 0;
    const comparisonCount = coverage.find(entry => entry.year === comparisonYear)?.assetCount ?? 0;
    const bothKnown = baselineCount > 0 && comparisonCount > 0;
    return bothKnown && baselineCount !== comparisonCount;
};

type LandCoverYears = { metricWithTrend?: object; yearCoverage?: LandCoverYearCoverage[] };

// Which year land cover compares against for the period the user picked. Only a partial
// latest year has a separate last full year to choose; otherwise it is the current year.
export const landCoverComparison = (landCover: LandCoverYears, period: ComparisonPeriod) => {
    const years = Object.keys(landCover.metricWithTrend ?? {})
        .map(Number)
        .sort((a, b) => a - b);
    const coverage = landCover.yearCoverage ?? [];
    const currentYear = years[years.length - 1];
    const lastFullYear = comparisonYearFor(years, coverage, 'lastFull');
    const hasLastFullYear = lastFullYear !== undefined && lastFullYear !== currentYear;
    const shownPeriod: ComparisonPeriod = hasLastFullYear ? period : 'current';
    const comparisonYear = comparisonYearFor(years, coverage, shownPeriod) ?? currentYear;
    return { years, coverage, comparisonYear, shownPeriod, hasLastFullYear };
};

// Every year any habitat card has data for, so one baseline can serve them all.
export const habitatYears = (metrics: PortfolioSiteMetric[]): number[] => {
    const years = new Set<number>();
    metrics.forEach(metric => {
        Object.keys(metric.metricWithTrend ?? {}).forEach(year => years.add(Number(year)));
        (metric.years ?? []).forEach(year => years.add(year));
    });
    return [...years].sort((a, b) => a - b);
};
